import "./styles/SettingsPage.scss";
import React from "react";
import {AsyncGroupSelect} from "./AsyncGroupSelect";

function SettingsPage() {
    AP.sizeToParent(true);

    return (
        <div className={"ac-content menu-settings desktop-view"}>
            <div className={"admin-heading-wrapper "}>
                <h1 className="admin-heading">Menu Settings</h1>
            </div>

            <div className={"desc"}>
                <h3>Editor permissions</h3>
                <p>Grant permission to groups to edit menus. Confluence admins are always able to edit menus.</p>
            </div>

            <div>
                <AsyncGroupSelect/>
            </div>
        </div>
    );
}

export default SettingsPage;
